import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Loading from '../Loading';
import Button from '../Button';
import {
  ContainerStyled,
  NewParagraphStyled,
  NewParagraphStrongStyled,
} from './styles/ForbiddenStyled';
import ServicError from '../AccessCode/ServiceError';
import { ReactComponent as NoAccessSvg } from '../../../images/errores/forbidden.svg';
import { GoogleTagManager, redirectToExternalPage } from '../../../helpers';
import CustomerService from '../../../services/Customer';
import useUser from '../../../hooks/useUser';

const Forbidden = ({ phoneNumber, tag }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [adminNumber, setAdminNumber] = useState('');

  const getData = () => {
    setLoading(true);
    CustomerService.getAvailableChangeNumberAdministrator()
      .then(([response]) => {
        setAdminNumber(response.adminNumber);
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  };

  const {
    plan: { number: planNumber },
  } = useUser();

  useEffect(() => {
    if (tag && Object.values(tag).every(value => value !== '')) {
      GoogleTagManager.pushToDataLayer(tag);
    }
    getData();
  }, []);

  if (error) {
    return (
      <ContainerStyled>
        <ServicError retryCallback={getData} />
      </ContainerStyled>
    );
  }
  return (
    <ContainerStyled>
      {loading && !error ? (
        <Loading />
      ) : (
        <>
          <NoAccessSvg />
          <NewParagraphStyled>
            {`¡Hola! recuerda que solo el administrador de esta línea ${
              adminNumber && adminNumber === planNumber
                ? ''
                : `+(${adminNumber})`
            } tiene permiso para ver esta sección.`}
          </NewParagraphStyled>
          <NewParagraphStrongStyled>
            Puedes socilitar tu cambio de administrador
          </NewParagraphStrongStyled>
          <Button
            color="bubbleGum"
            maxWidth="280px"
            click={() => {
              const urlWs = `https://wa.me/56935223070?text=¡Hola!+Quisiera+cambiar+el+administrador+de+la+línea+Nro:+${phoneNumber}`;
              redirectToExternalPage(urlWs, true);
            }}
          >
            SOLICITAR CAMBIO
          </Button>
        </>
      )}
    </ContainerStyled>
  );
};

Forbidden.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  tag: PropTypes.shape({
    event: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    pagename: PropTypes.string.isRequired,
  }),
};

Forbidden.defaultProps = {
  tag: {
    event: '',
    page: '',
    pagename: '',
  },
};
export default Forbidden;
